var _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path2, _ellipse5, _ellipse6, _ellipse7, _ellipse8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopRightBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 818,
    viewBox: "0 0 296 818",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M519.048 626.866L356.305 548.168M356.305 548.168L323.224 633.429M356.305 548.168L264.086 460.319M323.224 633.429L215.822 702.503M323.224 633.429L536.39 745.895M323.224 633.429L264.086 460.319M264.086 460.319L265.87 269.384L160.12 190.529L264.086 460.319Z",
    stroke: "#D8D8D8",
    strokeWidth: 4
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 214.721,
    cy: 706.213,
    rx: 15.4219,
    ry: 15.9073,
    transform: "rotate(-163.5 214.721 706.213)",
    fill: "#34A853"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.27149,
    cy: 9.08844,
    rx: 9.27149,
    ry: 9.08844,
    transform: "matrix(-0.136175 -0.990684 0.987172 -0.159657 255.818 473.115)",
    fill: "#EA4335"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.1512,
    cy: 13.8719,
    rx: 14.1512,
    ry: 13.8719,
    transform: "matrix(-0.136175 -0.990684 0.987172 -0.159657 256.116 288.515)",
    fill: "#4285F4"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.02751,
    cy: 8.84928,
    rx: 9.02751,
    ry: 8.84928,
    transform: "matrix(-0.136175 -0.990684 0.987172 -0.159657 153.991 202.242)",
    fill: "#34A853"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M163.383 434.921L321.958 348.129M321.958 348.129L271.756 271.687M321.958 348.129L447.029 324.067M271.756 271.687L277.89 144.137M271.756 271.687L56.4097 379.919M271.756 271.687L447.029 324.067M447.029 324.067L601.436 436.396L727.043 396.094L447.029 324.067Z",
    stroke: "#D8D8D8",
    strokeWidth: 4
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 269.32,
    cy: 271.953,
    rx: 15.8386,
    ry: 16.3373,
    transform: "rotate(-38 269.32 271.953)",
    fill: "#EA4335"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 166.222,
    cy: 436.522,
    rx: 24.1748,
    ry: 24.9358,
    transform: "rotate(-38 166.222 436.522)",
    fill: "#4285F4"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 54.4299,
    cy: 378.738,
    rx: 16.6723,
    ry: 17.1971,
    transform: "rotate(-38 54.4299 378.738)",
    fill: "#F9AB00"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.509,
    cy: 141.086,
    rx: 15.4219,
    ry: 15.9073,
    transform: "rotate(-38 275.509 141.086)",
    fill: "#34A853"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopRightBg);
export default __webpack_public_path__ + "static/media/top-right-bg.c5bfd8755985525958a958d1867479e6.svg";
export { ForwardRef as ReactComponent };